import { Dropdown, Form } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import ErrorsView from "./ErrorsView";
import { PermitType } from "../models/PermitType";

export interface FormData {
  permitTypeIds: string[];
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  availablePermitTypes?: PermitType[];
}

const AddPermitTypeToRegisterForm = ({ formData, formErrors, errors, onChange, availablePermitTypes }: Props) => {
  const handleChange = (_: any, { value }: any) => {
    onChange({ ...formData, permitTypeIds: value as string[] });
  };

  return (
    <>
      <Form style={{ padding: "14px" }}>
        <Form.Field
          required
          error={formErrors.permitTypeIds}
          control={Dropdown}
          name="permitTypeIds"
          value={formData.permitTypeIds ?? []}
          fluid
          label="Permit types"
          options={availablePermitTypes?.map((t) => ({ key: t.id, text: t.name, value: t.id })) ?? []}
          onChange={handleChange}
          multiple
          selection
          search
          placeholder="Select permit types..."
        />
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddPermitTypeToRegisterForm;

